var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValueChainObligation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs970"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath980"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path978"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1012"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1010"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g972",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g976",
    clipPath: "url(#clipPath980)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g982",
    transform: "translate(437,46.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -422 V 180 H 0 L 60,90 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path984"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g986",
    transform: "translate(286,226.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 60,-90 0,-180",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path988"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g990",
    transform: "translate(136,226.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 60,-90 0,-180",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path992"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g994",
    transform: "translate(76,286.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -60",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path996"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g998",
    transform: "translate(226,346.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -120",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1002",
    transform: "translate(376,286.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -60",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1004"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1008",
    clipPath: "url(#clipPath1012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1014",
    transform: "translate(46,376.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 30,-30 90,30",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1016"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1018",
    transform: "translate(196,436.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 30,-30 90,30",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1020"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1022",
    transform: "translate(346,376.0356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 30,-30 90,30",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueChainObligation);
export default __webpack_public_path__ + "static/media/value-chain-obligation.4a25d051997d1992fb8ed4f05b9ba8d6.svg";
export { ForwardRef as ReactComponent };